import { PublicClientApplication, Configuration } from "@azure/msal-browser";

// Azure AD configuration
const msalConfig: Configuration = {
  auth: {
    clientId: "08cb1d9c-cad8-46e7-8141-dfda0fadf0af",
    authority: "https://login.microsoftonline.com/4d04cbce-1a4a-41a6-a570-7a62a5771355",
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: "localStorage",
    // Persist auth state in a cookie so the hidden-iframe silent token renewal
    // survives third-party cookie restrictions. Without this, iframe renewal
    // fails with AADSTS160021 ("user session does not exist") and API calls 401.
    storeAuthStateInCookie: true,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        console.log(message);
      },
    },
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);

export const loginRequest = {
  scopes: ["openid", "profile", "email"],
};

export const tokenRequest = {
  scopes: [`${msalConfig.auth.clientId}/.default`], // Use client ID as scope for API access
};

// Azure AD group ID for admin access
export const ADMIN_GROUP_ID = 'd97407b2-2c7e-4547-b850-a7e45fcc32ca';

// Microsoft Graph token request for SharePoint file access
export const graphTokenRequest = {
  scopes: ['https://graph.microsoft.com/Files.ReadWrite.All'],
};